exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".unsubscribed-1{fill:none}.unsubscribed-2{fill:#fad1d0}.unsubscribed-3{fill:#1e4e69}.unsubscribed-4{fill:#fff}\n", ""]);
